import { select, createSelector } from '@ngrx/store';
import { State } from '@app/core/features';
import { Polygon, ProductListState } from './product.models';

const getLocalState = (state: State): ProductListState => state.products;

const isFetching = createSelector(
  getLocalState,
  (state: ProductListState): boolean => state.isFetching
);

const getProductList = createSelector(
  getLocalState,
  (state: ProductListState): any[] => state.data
);

const getProductPolygons = createSelector(
  getLocalState,
  (state: ProductListState): any[] => {
    return state.data.map(z => z.polygon);
  }
);

const getProductBySkuAPI = createSelector(
  getLocalState,
  (state: ProductListState): any => state.product
);

const isProductDetailFetching = createSelector(
  getLocalState,
  (state: ProductListState): any => state.isProductDetailFetching
);

const getProductBySku = (sku: string) => createSelector(
  getLocalState,
  (state: ProductListState): Polygon => {
    return (state.data.length > 0 && state.data.map(z => z.polygon))
      ? state.data.map(z => z.polygon).find(x =>
        x.feature.properties.SKU === sku).feature.geometry
      : null;
  }
);

export const selectors = {
  isFetching: select(isFetching),
  getProductList: select(getProductList),
  getProductPolygons: select(getProductPolygons),
  getProductBySku: (sku: string) => select(getProductBySku(sku)),
  getProductBySkuAPI: select(getProductBySkuAPI),
  isProductDetailFetching: select(isProductDetailFetching)
};
